





















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import {
  appFunc_callExit,
  appFunc_senToken,
  appFunc_callRealManAuth,
  appFunc_RealManAuthCallBack
} from '@/utils/bridge'
import { CommonModule } from '@/store/modules/common'
import { getAppWithdrawConfigList, apiGetIosVerify } from '@/api'
import PopUp from './components/PopUp.vue'
import CertificationPopup from './components/CertificationPopup.vue'
import { Toast } from 'vant'
@Component({
  name: 'exchange',
  components: {
    PopUp,
    CertificationPopup
  }
})
export default class Exchange extends Vue {
  list: any = []
  // 当前用户积分数量
  goldBean = 0
  // 今日收益
  todayIncome = 0
  // 昨日收益
  yesterdayIncome = 0
  // 实名状态(0-未实名,1-已实名)
  verification = 0
  // 真人认证状态 0 未认证 1 已认证 2审核不通过
  realManAuthState = 0
  // 是否显示实名弹窗
  isshow = false
  // 是否显示真人认证弹窗
  isPopup = false
  isLoading = false
  isIos = true
  showUpdate = false
  showIosToast = false
  isIosShow = false
  async created() {
    this.init()
  }

  mounted() {
    // 进入-提现
    const { aplus_queue }: any = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['enter_withdrawal', 'CLK']
    })
    // 挂载完成后，判断浏览器是否支持popstate--物理返回键
    if (window.history && (window.history.pushState as any)) {
      history.pushState(null, '', document.URL)
      window.addEventListener('popstate', this.handelBack, false)
    }
  }

  //页面销毁时，取消监听。否则其他vue路由页面也会被监听--物理返回键
  destroyed() {
    window.removeEventListener('popstate', this.handelBack, false)
  }
  async init() {
    return new Promise<void>(async (resolve, reject) => {
      try {
        this.checkisIos()
        await this.getToken()

        // 获取ios金豆审核状态
        this.getIosVerify()

        //  获取金豆提现配置列表
        await this.getAppWithdrawConfigList()

        // 获取当前语言
        const data = (this.$route.query.language as string) || 'ug'
        this.getLanguage(data)
        CommonModule.setLanguage(data)

        // 获取用户id
        const userId = this.$route.query.userId as any
        CommonModule.setUserId(userId)
        resolve()
      } catch (error) {
        Toast(CommonModule.DefaultToast)

        reject()
      }
    })
  }
  async getIosVerify() {
    if (!this.isIos) {
      return
    }
    const { code, data } = await apiGetIosVerify()
    if (code === 1001) {
      this.isIosShow = data.iosGoldWithdrawSwitch
    }
  }
  checkisIos() {
    if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
      this.isIos = true
    } else if (/(Android)/i.test(navigator.userAgent)) {
      this.isIos = false
    } else {
      this.isIos = true
    }
  }
  // 获取积分提现配置列表
  async getAppWithdrawConfigList() {
    const { data, code } = await getAppWithdrawConfigList()
    if (code == 1001) {
      const {
        list,
        goldBean,
        todayIncome,
        yesterdayIncome,
        verification,
        realManAuthState
      } = data
      this.list = list
      this.goldBean = goldBean
      this.todayIncome = todayIncome
      this.yesterdayIncome = yesterdayIncome
      this.verification = verification
      this.realManAuthState = realManAuthState
      console.log(data)
    } else {
      Toast(CommonModule.DefaultToast)
    }
  }

  handelOverlay() {
    this.isshow = false
  }
  async onRefresh() {
    await this.init()
    //接口太快了，为了看到加载状态，延迟一秒结束加载状态
    setTimeout(() => {
      Toast(this.$t('刷新成功'))
      this.isLoading = false
    }, 1000)
  }
  // 暂时取消
  handleWithout() {
    this.isPopup = false
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  async getToken() {
    const res = await appFunc_senToken()
    console.log(res, '/////////////')
    CommonModule.setUserId(res.id)
    CommonModule.setToken(res.tokenForJs)
    CommonModule.setUserPhone(res.mobile)
    CommonModule.setUserName(res.name)
  }

  // 返回
  handelBack() {
    appFunc_callExit()
  }

  // 进入积分清单
  handelList() {
    this.$router.push({
      path: '/inventory',
      query: {
        language: this.language
      }
    })
  }

  // 真人认证
  handleCertification() {
    appFunc_callRealManAuth()
    appFunc_RealManAuthCallBack(this.handleSuccess)
    this.isPopup = false
  }

  // 真人认证成功回调
  handleSuccess(data: any) {
    console.log(data, 'App返回参数')
    console.log('真人认证成功回调', '///')
    if (data === 'true') {
      this.getAppWithdrawConfigList()
    }
  }
  updateUrl() {
    this.checkisIos()
    if (this.isIos) {
      window.location.href = 'https://apps.apple.com/us/app/allo/id1664635935'
      return
    }
    window.location.href = 'http://web.allosoft.top/h5/main/#/download-allo'
  }
  // 进入确认兑换
  handelExchange(item: any) {
    // if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
    //   // this.showIosToast = true
    //   // return
    //   // 是否实名认证
    //   if (this.verification) {
    //     if (this.goldBean >= item.goldenBean) {
    //       this.$router.push({
    //         path: '/exchange-confirm',
    //         query: {
    //           language: this.language,
    //           list: JSON.stringify(item)
    //         }
    //       })
    //       // 选择提现金额
    //       const { aplus_queue }: any = window
    //       aplus_queue.push({
    //         action: 'aplus.record',
    //         arguments: ['select_withdrawal_money', 'CLK']
    //       })
    //     } else {
    //       Toast(this.$t('金豆不足，暂时无法兑换'))
    //     }
    //   } else {
    //     console.log('未实名认证')
    //     // 实名认证弹窗
    //     this.isshow = true
    //     // 金豆-实名认证弹窗
    //     const { aplus_queue }: any = window
    //     aplus_queue.push({
    //       action: 'aplus.record',
    //       arguments: ['real_name_authentication_popup', 'CLK']
    //     })
    //   }
    // } else if (/(Android)/i.test(navigator.userAgent)) {
    console.log(CommonModule.appVersion, 'App版本号///////')
    // const appVersion = CommonModule.appVersion
    // 是否实名认证
    // if (appVersion < '3.3.1') {
    //   this.showUpdate = true
    //   return
    // }
    if (this.goldBean < item.goldenBean) {
      Toast(this.$t('积分不足，暂时无法兑换'))
      return
    }
    if (this.verification) {
      console.log('已实名认证')
      if (this.realManAuthState == 1) {
        console.log('已真人认证')
        if (this.goldBean >= item.goldenBean) {
          this.$router.push({
            path: '/exchange-confirm',
            query: {
              language: this.language,
              list: JSON.stringify(item)
            }
          })
          // 选择提现金额
          const { aplus_queue }: any = window
          aplus_queue.push({
            action: 'aplus.record',
            arguments: ['select_withdrawal_money', 'CLK']
          })
        } else {
          Toast(this.$t('积分不足，暂时无法兑换'))
        }
      } else {
        console.log('未真人认证')
        // 真人认证弹窗
        this.isPopup = true
      }
    } else {
      console.log('未实名认证')
      // 实名认证弹窗
      this.isshow = true
      // 金豆-实名认证弹窗
      const { aplus_queue }: any = window
      aplus_queue.push({
        action: 'aplus.record',
        arguments: ['real_name_authentication_popup', 'CLK']
      })
    }
    // } else {
    //   return false
    // }
  }

  // 进入积分问题
  handelProblem() {
    console.log('进入积分问题')
    this.$router.push({
      path: '/question',
      query: {
        language: this.language
      }
    })
  }
}
